import { render, staticRenderFns } from "./QaForm.vue?vue&type=template&id=614a7895&"
import script from "./QaForm.vue?vue&type=script&lang=js&"
export * from "./QaForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('614a7895')) {
      api.createRecord('614a7895', component.options)
    } else {
      api.reload('614a7895', component.options)
    }
    module.hot.accept("./QaForm.vue?vue&type=template&id=614a7895&", function () {
      api.rerender('614a7895', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gift/basic/qa/modules/QaForm.vue"
export default component.exports